/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { fulfillmentLabels } from '../../constants/fulfillmentConstants';
import type { FulfillmentOption } from '@/types/reduxStore/skuDetails';
import styles from './styles.module.scss';
import { OrderWithinHrsMinArrivesMessage } from './FulfillmentCutoff';
import { useLabel } from '@/hooks/useLabels';

export default function NextDayOption({ option }: { option: FulfillmentOption }) {
  const inStockLabel = useLabel('label_cart_lineItem_InStock');

  return (
    <>
      <div className={styles.NextDaylistItemContainer} data-testid="next-day-delivery">
        <div data-testid="next-day" className={styles.inStockLabel}>
          <div className={styles.inStockLabelContainer}>
            <div className={styles.tickmarkContainer}>
              <img src="/images/green-tickmark.svg" alt="" />{' '}
            </div>
            <span>
              <span className={styles.successBoldedMessage}>{inStockLabel}</span>
              <span> | </span>
              {option.available && option.estimatedDeliveryDate && option.fullfillmentCutOffDate ? (
                <OrderWithinHrsMinArrivesMessage
                  estDeliveryDateString={option.estimatedDeliveryDate}
                  cutOffDateString={option.fullfillmentCutOffDate}
                  arrivesByLabel={fulfillmentLabels.label_shipping_cutoff_hrsmin_tail}
                  displayAmPmFormat={false}
                  shippingArriveBy={fulfillmentLabels.label_shipping_arriveBy}
                  isNdd={true}
                />
              ) : (
                <span className={styles.deliveryMessage}>{option.availableLabel}</span>
              )}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
